export default __webpack_public_path__ + "static/media/insights.aa7d12f6.png";